import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import User from './User';

interface Renditions {
  thumbnail: string | null;
  medium: string | null;
  large: string | null;
  xlarge: string | null;
  original: string | null;
  [key: string]: string | null;
}

@Model()
export default class Media extends ApplicationRecord {
  static jsonapiType = 'media';

  static cacheName = 'media';

  // --- Attributes
  // --------------

  // readOnly
  @Attr() renditions!: Renditions | null;

  // readOnly
  @Attr() createdAt!: string | null;

  // readOnly
  @Attr() modifiedAt!: string | null;

  // --- Relationships
  // -----------------

  // nullable
  @HasOne() createdBy!: User | null;

  // nullable
  @HasOne() modifiedBy!: User | null;

  // --- Paths
  // ---------

  /**
   * /backend/api/v1/media/{id}/
   *
   * Method: get
   * Params:
   *   - id: string (required)
   *   - include: string
   *   - fields: object
   *   - sort: string
   *   - sort: string
   *   - filter[search]: string
   *
   */
}

type Ext<T extends typeof Media> = T;

let Klass: Ext<typeof Media> = Media;
let frozen = false;

export const setMediaClass = (klass: typeof Klass) => {
  if (frozen) {
    throw new Error('Cannot set - Media class is frozen');
  }
  Klass = klass;
};

export const getMediaClass = () => {
  return Klass;
};

export const freezeMediaClass = () => {
  frozen = true;
};
